import Enhancer from '../enhancer';
import EnhancerApp from '../enhancer-app';
import * as cookie from '../utils/cookie';

export default class RegionSelector extends Enhancer {
    animationDelay = 0;
    backdropAnimationDelay = 100;
    opener = null;
    isShown = false;
    handleEscKeyBind = null;
    handleTabKeyBind = null;
    buttonText = null;
    activeDistrict = null;

    init() {
        this.openers.forEach((opener) => {
            opener.addEventListener('click', this.show.bind(this), true);
        });

        this.closers.forEach((opener) => {
            opener.addEventListener('click', this.hide.bind(this), false);
        });

        this.selectableRegions.forEach((region) => {
            region.addEventListener(
                'click',
                this.setActiveRegionCookie.bind(this)
            );
        });
    }

    show(e) {
        if (this.isShown) {
            this.hide();
            return;
        }

        this.opener = e.currentTarget;
        this.opener.setAttribute('aria-expanded', 'true');

        this.wrapper.setAttribute('aria-hidden', false);

        setTimeout(() => {
            document
                .querySelector('body')
                .classList.add('region-selector-open');

            //TODO: set active elemtn in focus and handle tabbing thorugh items
            this.wrapper.focus();
        }, this.animationDelay);

        // Keep tab focus inside nav pane
        this.handleTabKeyBind = this.handleTabKey.bind(this);
        this.wrapper.addEventListener('keydown', this.handleTabKeyBind, true);

        // Hide when escape is pressed
        this.handleEscKeyBind = this.handleEscKey.bind(this);
        this.wrapper.addEventListener('keyup', this.handleEscKeyBind, true);

        this.isShown = true;
    }

    hide() {
        if (!this.isShown) {
            return;
        }

        this.wrapper.removeEventListener(
            'keydown',
            this.handleTabKeyBind,
            false
        );

        this.wrapper.removeEventListener('keyup', this.handleEscKeyBind, false);
        this.handleTabKeyBind = null;
        this.handleEscKeyBind = null;

        // set expanded a bit earlier to prevent screen readers from reading expanded=true
        this.opener.setAttribute('aria-expanded', 'false');

        setTimeout(() => {
            this.wrapper.setAttribute('aria-hidden', 'true');

            this.opener.focus();
            this.opener = null;
            this.isShown = false;
        }, this.animationDelay);
    }

    handleEscKey(e) {
        if (e.keyCode === 27 && this.isShown) {
            e.preventDefault();
            this.hide();
        }
    }

    handleTabKey(e) {
        // if tab is pressed
        if (e.keyCode === 9) {
            var focusableItemsSelector =
                    'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
                focusableItems = this.getAll(focusableItemsSelector),
                focusedItem = document.activeElement,
                numberOfFocusableItems = focusableItems.length,
                focusedItemIndex = Array.from(focusableItems).indexOf(
                    focusedItem
                );

            if (e.shiftKey) {
                //back tab
                // if focused on first item and user preses back-tab, go to the last focusable item
                if (focusedItemIndex === 0) {
                    focusableItems[focusableItems.length - 1].focus();
                    e.preventDefault();
                }
            } else {
                //forward tab
                // if focused on the last item and user preses tab, go to the first focusable item
                if (focusedItemIndex === numberOfFocusableItems - 1) {
                    focusableItems[0].focus();
                    e.preventDefault();
                }
            }
        }
    }

    setActiveRegionCookie(e) {
        cookie.set(this.cookieName, e.target.getAttribute('data-value'));
        e.target.classList.add('active');
    }

    get cookieName() {
        return this.getData('cookie-name');
    }

    get wrapper() {
        return this.element;
    }

    get RegionSelector() {
        return this.get('.region-selector');
    }

    get selectableRegions() {
        return Array.from(document.querySelectorAll('.selectable-region'));
    }

    get openers() {
        return Array.from(
            document.querySelectorAll(`[data-target="#${this.element.id}"]`)
        );
    }

    get closers() {
        return this.getAll(`[data-dismiss="region-selector"]`);
    }
}

EnhancerApp.register('RegionSelector', RegionSelector);
